import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {
    assignDocumentToJob,
    getJobDocumentDownloadUrl,
    listJobDocuments,
    unassignDocumentFromJob,
} from './api'
import {jobDocumentKeys} from './query-keys'
import type {AssignDocumentRequest} from './schemas'

export function useJobDocuments(jobId: string, options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: jobDocumentKeys.list(jobId),
        queryFn: () => listJobDocuments(jobId),
        enabled: options?.enabled ?? Boolean(jobId),
    })
}

export function useAssignDocumentToJob(jobId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: AssignDocumentRequest) => assignDocumentToJob(jobId, input),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: jobDocumentKeys.lists(jobId),
            })
        },
    })
}

export function useUnassignDocumentFromJob(jobId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (documentId: string) => unassignDocumentFromJob(jobId, documentId),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: jobDocumentKeys.lists(jobId),
            })
        },
    })
}

export {getJobDocumentDownloadUrl}
